import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut } from '../utils/axios';

const GET_PLAY_POINTS_DISCOUNT_REPORT = SERVER_URI + '/reports/get-play-points-discount-report';
const GET_CONSOLIDATED_CUOPON_REPORT = SERVER_URI + '/reports/get-consolidated-cuopon-report';
const GET_PRODUCT_DISCOUNT_REPORT = SERVER_URI + '/reports/get-product-discount-report';
const GET_PLAY_POINTS_CUOPON_REPORT = SERVER_URI + '/reports/get-play-points-cuopon-report';

const GET_PACKAGE_CUOPON_REPORT=SERVER_URI + '/reports/get-package-cuopon-report';
const GET_PARTY_DISCOUNT_REPORT=SERVER_URI + '/reports/get-party-discount-report';



export default {
    getPlayPointsDiscountReport: async function (payload) {
        return apiPost(GET_PLAY_POINTS_DISCOUNT_REPORT, payload)
    },
    getConsolidatedCuoponReport: async function (payload) {
        return apiPost(GET_CONSOLIDATED_CUOPON_REPORT, payload)
    },
    getProductDiscountReport: async function (payload) {
        return apiPost(GET_PRODUCT_DISCOUNT_REPORT, payload)
    },
    getPlayPointsCuoponReport: async function (payload) {
        return apiPost(GET_PLAY_POINTS_CUOPON_REPORT, payload)
    },
    getPackageCuoponReport: async function (payload) {
        return apiPost(GET_PACKAGE_CUOPON_REPORT, payload)
    },
    getPartyDiscountReport: async function (payload) {
        return apiPost(GET_PARTY_DISCOUNT_REPORT, payload)
    }
};



